import { SxProps, Theme } from '@mui/material';
import { ReceiptStatusEnum } from '@pxtra-client-lib-legacy/gen';
import { FC } from 'react';
import {
  ApprovedIcon,
  StatusEditIcon,
  StatusRejectedIcon,
  StatusSubmittedIcon,
  StatusSuccessIcon
} from '../../../icons';
import { IconProps } from '../../../icons/templates/icon';

interface Icon {
  component: FC<IconProps>;
  color: string;
}

const iconMap: Record<ReceiptStatusEnum, Icon> = {
  DRAFTED: { component: StatusEditIcon, color: 'grey.900' },
  SUBMITTED: { component: StatusSubmittedIcon, color: 'heaven.main' },
  REJECTED: { component: StatusRejectedIcon, color: 'error.main' },
  APPROVED: { component: ApprovedIcon, color: 'success.main' },
  BILLED: { component: StatusSuccessIcon, color: 'success.main' },
  ARCHIVED: { component: StatusRejectedIcon, color: 'grey.100' },
  DELETION_SUBMITTED: { component: StatusRejectedIcon, color: 'grey.100' }
};

interface Props {
  status: ReceiptStatusEnum;
  height?: number;
  width?: number;
  sx?: SxProps<Theme>;
}

export const ReceiptStatusIcon: FC<Props> = ({ status, height, width, sx }) => {
  const Component = iconMap[status].component;
  const color = iconMap[status].color;
  return <Component color={color} height={height} width={width} sx={sx} />;
};
